var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "search-ia-dislike-container" },
    [
      _c("CustomDialogHeaderComponent", {
        attrs: { headerTitle: _vm.TEXT.title },
      }),
      _c("LexonTextAreaComponent", {
        attrs: {
          label: _vm.TEXT.label,
          placeholder: _vm.TEXT.placeholder,
          maxlength: 3000,
          validationRules: "required",
        },
        model: {
          value: _vm.opinion,
          callback: function ($$v) {
            _vm.opinion = $$v
          },
          expression: "opinion",
        },
      }),
      _c("CustomDialogActionButtonsComponent", {
        attrs: {
          disabledButtons: !_vm.opinion.trim(),
          mainAction: _vm.sendDislike,
          primaryButtonText: _vm.TEXT.sendButton,
          secondaryButtonText: _vm.TEXT.cancelButton,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }